import React from 'react'
import { IModel } from '@linqpal/models'
import { S3_DOC_NAME, Upload } from '../components'
import ProjectStore from '../Store'

const NoticeOfCommencement: React.FC<{ model: IModel }> = ({ model }) => {
  const filled = ProjectStore.formData?.data
    ?.get('propertyAddress')
    ?.items.find((i) => i.identifier === 'noticeOfCommencement')?.filled
  const onSuccess = (url) => {
    model.setValue(url)
  }
  const onDelete = () => {
    model.setValue('')
  }
  return (
    <Upload
      docName={S3_DOC_NAME.NOTICE}
      onSuccess={onSuccess}
      onDelete={onDelete}
      uploaded={filled}
    />
  )
}

export default {
  identifier: 'noticeOfCommencement',
  title: 'Please upload a notice of commencement',
  optional: true,
  component: NoticeOfCommencement,
}
